<!-- eslint-disable max-len -->
<template>
  <div
    class="
      block
      relative
      walter-block
      bg-white
      mb-2
      overflow-hiddens
      accordian-block
    "
  >
    <div class="card tab">
      <input
        id="tab-single6"
        class="card-heading absolute opacity-0"
        type="checkbox"
        name="tabs1"
      />
      <label
        class="
          card-heading
          cursor-pointer
          flex
          items-center
          justify-between
          mb-0
          pt-3
          pb-3
          rounded-t-lg
          tab
          w-full
          solid
          border-agray1
        "
        for="tab-single6"
      >
        <span class="block relative text-sm font-bold text-darkblack">
          {{ $t("pages.questionnaire.sixth_collapse.label") }}
        </span>
        <span class="flex transform rotate-180 duration-100 iconbox">
          <svg
            class="w-4 h-4"
            viewBox="0 0 16 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.4957 7.50767C14.3637 7.50455 14.2382 7.44932 14.1467 7.35403L8.00025 1.20754L1.85377 7.35403C1.80716 7.40202 1.7514 7.44018 1.68978 7.46623C1.62817 7.49229 1.56195 7.50572 1.49505 7.50572C1.39554 7.5057 1.2983 7.47598 1.21577 7.42039C1.13325 7.36479 1.06919 7.28583 1.03178 7.19362C0.994383 7.10141 0.985343 7.00014 1.00582 6.90276C1.0263 6.80538 1.07536 6.71633 1.14674 6.647L7.64674 0.146995C7.74051 0.0532622 7.86767 0.000607491 8.00025 0.000607491C8.13284 0.000607491 8.26 0.0532622 8.35377 0.146995L14.8538 6.647C14.9265 6.71678 14.9764 6.80691 14.997 6.90556C15.0176 7.00422 15.0079 7.10679 14.9692 7.19984C14.9305 7.29289 14.8646 7.37207 14.7801 7.427C14.6956 7.48193 14.5964 7.51005 14.4957 7.50767Z"
              fill="white"
            ></path>
          </svg>
        </span>
      </label>
      <div class="tab-content overflow-hidden card-body rounded-b-lg">
        <div class="block relative pl-4 pr-4 pt-2 pb-4">
          <div class="block relative form-group-main">
            <div class="block relative mb-2 form-group">
              <label
                class="
                  block
                  relative
                  text-sm
                  font-semibold
                  text-darkblack
                  mb-1
                "
              >
                {{ $t("pages.questionnaire.sixth_collapse.customer_since") }}
              </label>
              <label
                class="
                  block
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                  mb-1
                "
              >
                {{
                  formatDate(details.customer_since, "DD.MM.YYYY", "YYYY-MM-DD")
                }}
              </label>
            </div>

            <div class="block relative mb-2 form-group">
              <label
                class="
                  block
                  relative
                  text-sm
                  font-semibold
                  text-darkblack
                  mb-1
                "
              >
                {{
                  $t("pages.questionnaire.sixth_collapse.supervision_on_site")
                }}
              </label>
              <label
                class="
                  block
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                  mb-1
                "
              >
                {{ details.customer_care_agent }}
              </label>
            </div>

            <div class="block relative mb-2 form-group">
              <label
                class="
                  block
                  relative
                  text-sm
                  font-semibold
                  text-darkblack
                  mb-1
                "
              >
                {{ $t("pages.questionnaire.sixth_collapse.all_mission") }}
              </label>
              <label
                class="
                  block
                  relative
                  text-sm
                  font-normal
                  text-darkgray1
                  mb-1
                "
              >
                {{ details.customer.all_missions }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoAboutCustomer",
  props: {
    details: {
      default: () => {
        return {};
      },
      type: Object,
    },
  },
};
</script>
